import React from 'react';
import PropTypes from 'prop-types';
import { SIZES } from '../constants';
import Icon from '../../icon';
import { iconsList } from '../../icon/glyphs';

const ActionItem = ({ size, iconGlyph }) => (
  <div className="ws-ui-color-selector__action-item">
    <Icon glyph={iconGlyph} size={size === SIZES.large ? 20 : 18} strokeWidth={1.5} type="light" />
  </div>
);

ActionItem.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)).isRequired,
  iconGlyph: PropTypes.oneOf(iconsList).isRequired,
};

export default ActionItem;
